"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    gridRow: {
        marginBottom: theme.spacing(2)
    },
    textFont: {
        fontSize: 14
    }
});
exports.default = styles;
//# sourceMappingURL=DetailPageStyles.js.map